import { Button, Card, Col, Form, message, Row } from "antd";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useMutation, useQuery } from "react-query";
import cmaApi from "../../../api/cmaApi";
import InputField from "../../../components/InputField";
import Loading from "../../../components/Loading";
import TopContent from "../../../components/TopContent";
import PageWrap from "../../../layout/PageWrap";
import { formItemLayout } from "../../../utils/constants";
import { messages } from "../../../utils/messages";

const CmaSiteSettings = () => {
  const { data, isLoading, isFetching }: any = useQuery(
    ["cma_site_settings"],
    cmaApi.getSiteSettings
  );

  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    if (data?.data) {
      reset({
        brand_name: data.data.brand?.name ?? "",
        contact_address: data.data.contact?.address ?? "",
        contact_address_en: data.data.contact?.address_en ?? "",
        contact_phone: data.data.contact?.phone ?? "",
        contact_email: data.data.contact?.email ?? "",
        social_linkedin: data.data.social?.linkedin ?? "",
        social_twitter: data.data.social?.twitter ?? "",
        social_instagram: data.data.social?.instagram ?? "",
      });
    }
  }, [data, reset]);

  const mutation = useMutation(cmaApi.editSiteSettings, {
    onSuccess: (res: any) => {
      if (res.statusCode === 200) {
        message.success(messages.updateSuccess);
      } else {
        message.error(res?.data?.message ?? messages.error);
      }
    },
    onError: (err: any) => {
      message.error(err?.data?.message ?? messages.error);
    },
  });

  const onSubmit = (dt: any) => {
    mutation.mutate({
      brand: { name: dt.brand_name },
      contact: {
        address: dt.contact_address,
        address_en: dt.contact_address_en,
        phone: dt.contact_phone,
        email: dt.contact_email,
      },
      social: {
        linkedin: dt.social_linkedin,
        twitter: dt.social_twitter,
        instagram: dt.social_instagram,
      },
    });
  };

  return (
    <PageWrap
      title="CMA · Cài đặt"
      content={
        <>
          <TopContent
            content={
              <Row>
                <Col>
                  <b>CMA · Cài đặt</b>
                </Col>
              </Row>
            }
          />
          <div className="content">
            {isLoading || isFetching ? (
              <div className="setting-loading">
                <Loading />
              </div>
            ) : (
              <Card bordered={false}>
                <Form {...formItemLayout}>
                  <Row gutter={[16, 10]}>
                    <Col lg={12} md={24}>
                      <InputField
                        name="brand_name"
                        control={control}
                        label="Brand name"
                        placeholder="CMA TRADING"
                        defaultValue={data?.data?.brand?.name}
                        errorMsg={errors?.brand_name?.message}
                      />
                      <InputField
                        name="contact_address"
                        control={control}
                        label="Address (VI)"
                        placeholder="Địa chỉ"
                        defaultValue={data?.data?.contact?.address}
                      />
                      <InputField
                        name="contact_address_en"
                        control={control}
                        label="Address (EN)"
                        placeholder="Address in English (để trống sẽ dùng bản VI)"
                        defaultValue={data?.data?.contact?.address_en}
                      />
                      <InputField
                        name="contact_phone"
                        control={control}
                        label="Phone"
                        placeholder="Phone"
                        defaultValue={data?.data?.contact?.phone}
                      />
                      <InputField
                        name="contact_email"
                        control={control}
                        label="Email"
                        placeholder="Email"
                        defaultValue={data?.data?.contact?.email}
                      />
                    </Col>
                    <Col lg={12} md={24}>
                      <InputField
                        name="social_linkedin"
                        control={control}
                        label="LinkedIn"
                        placeholder="https://..."
                        defaultValue={data?.data?.social?.linkedin}
                      />
                      <InputField
                        name="social_twitter"
                        control={control}
                        label="Twitter"
                        placeholder="https://..."
                        defaultValue={data?.data?.social?.twitter}
                      />
                      <InputField
                        name="social_instagram"
                        control={control}
                        label="Instagram"
                        placeholder="https://..."
                        defaultValue={data?.data?.social?.instagram}
                      />
                    </Col>
                  </Row>
                  <Row justify="start" gutter={[10, 0]}>
                    <Col>
                      <Button
                        type="primary"
                        danger
                        onClick={handleSubmit(onSubmit)}
                      >
                        Lưu
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </Card>
            )}
          </div>
        </>
      }
    />
  );
};

export default CmaSiteSettings;
